import {
  AppWindow,
  Bell,
  ClipboardList,
  FilePenLine,
  Footprints,
  KeyRound,
  Layers,
  LayoutDashboard,
  List,
  type LucideIcon,
  MapPin,
  MapPinPlus,
  Radio,
  RefreshCwOff,
  Route,
  ShieldAlert,
  Smartphone,
  Store,
  Tag,
  Timer,
  Upload,
  Users,
} from 'lucide-react';

/** The rail's icon per nav path (Tangram handoff). A path without one falls back to the list icon. */
export const NAV_ICONS: Record<string, LucideIcon> = {
  '/dashboard': LayoutDashboard,
  '/visits': List,
  '/assignments': ClipboardList,
  '/anomalies': ShieldAlert,
  '/sync-issues': RefreshCwOff,
  '/reports/travel': Timer,
  '/reports/activity': Footprints,
  '/tracking/live': Radio,
  '/tracking/route': Route,
  '/forms': FilePenLine,
  '/integrations/zoho': KeyRound,
  '/catalog/brands': Tag,
  '/catalog/branches': Store,
  '/catalog/geography': Layers,
  '/catalog/import': Upload,
  '/catalog/locations': MapPin,
  '/catalog/alerts': MapPinPlus,
  '/users': Users,
  '/users/devices': Smartphone,
  '/notifications': Bell,
  '/settings': AppWindow,
};
